// Types and Interfaces
import MenuCategory from "../../interfaces/MenuCategory";
// Images
import grilledChickenImage from "../../../assets/images/food/grilled-chicken.webp";
import babyBackRibsImage from "../../../assets/images/food/baby-back-ribs.webp";
import carneAsadaImage from "../../../assets/images/food/carne-asada.webp";
import tacosImage from "../../../assets/images/food/tacos-2.webp";
import pupusaImage from "../../../assets/images/food/pupusas.webp";
import quesadillasImage from "../../../assets/images/food/quesadillas.webp";
import mojarrasImage from "../../../assets/images/food/mojarra-frita.webp";
import pastelitosImage from "../../../assets/images/food/pastelitos.webp";
import tortillasImage from "../../../assets/images/food/tortillas.webp";
import beveragesImage from "../../../assets/images/food/aguas-frescas.webp";

const menuES: MenuCategory[] = [
    {
        name: "Pollo a la Parrilla",
        description: "Pollo jugoso y lleno de sabor con especias, asado al carbón.",
        image: grilledChickenImage,
        options: [
            { name: "Combo", price: 16, description: "Una porción perfecta de pollo con acompañamientos." },
            { name: "Combo Familiar", price: 31, description: "Comparte el sabor con toda la familia." },
        ],
    },
    {
        name: "Costillas Asadas de Cerdo",
        description: "Jugosas costillas asadas al carbón con salsa BBQ.",
        image: babyBackRibsImage,
        options: [
            { name: "Combo", price: 16, description: "Costillas tiernas cubiertas con rica salsa BBQ." },
            { name: "Combo Familiar", price: 61, description: "Un festín de costillas para todos." },
        ],
    },
    {
        name: "Carne Asada",
        description: "Jugoso filete asado al carbón servido con arroz y frijoles.",
        image: carneAsadaImage,
        options: [
            { name: "Combo", price: 20, description: "Filete jugoso con acompañamientos tradicionales, un clásico." },
        ],
    },
    {
        name: "Tacos",
        description: "Deliciosos tacos frescos con sabores auténticos.",
        image: tacosImage,
        options: [
            { name: "Pollo Asado x3", price: 10, description: "Pollo a la parrilla tierno con un sazón delicioso." },
            { name: "Al Pastor x3", price: 10, description: "Cerdo jugoso marinado con especias y piña." },
            { name: "Carne Asada x3", price: 10, description: "Filete a la parrilla con un toque ahumado." },
            { name: "Camarón", price: 4, description: "Camarones jugosos con un toque picante." },
        ],
    },
    {
        name: "Pupusas",
        description: "Auténticas pupusas hondureñas rellenas de ingredientes deliciosos.",
        image: pupusaImage,
        options: [
            { name: "Chicharrón x3", price: 10, description: "Crujiente carne de cerdo en cada bocado." },
            { name: "Pollo x3", price: 10, description: "Pollo tierno perfectamente sazonado y relleno." },
            { name: "Frijoles x3", price: 10, description: "Frijoles cremosos y sustanciosos con un toque tradicional." },
            { name: "Queso x3", price: 10, description: "Queso fundido para un sabor cremoso y delicioso." },
            { name: "Mixta x3", price: 10, description: "Una deliciosa combinación de queso, frijoles y carne." },
        ],
    },
    {
        name: "Quesadillas",
        description: "Quesadillas frescas con tortillas de maíz y queso fundido.",
        image: quesadillasImage,
        options: [
            { name: "Pollo", price: 8, description: "Pollo tierno con queso fundido en cada bocado." },
            { name: "Al Pastor", price: 8, description: "Cerdo marinado dulce y sabroso con queso fundido." },
            { name: "Carne Asada", price: 8, description: "Filete a la parrilla con un acabado crujiente y con queso." },
        ],
    },
    {
        name: "Mojarra Frita",
        description: "Mojarra crujiente, sazonada a la perfección.",
        image: mojarrasImage,
        options: [
            { name: "Pescado", price: 10, description: "Mojarra perfectamente frita y crujiente, sazonada justo a la medida." },
        ],
    },
    {
        name: "Pastelitos",
        description: "Pastelitos estilo hondureño, crujientes y deliciosos.",
        image: pastelitosImage,
        options: [
            { name: "Pollo", price: 7, description: "Pollo sabroso envuelto en masa hojaldrada." },
            { name: "Al Pastor", price: 10, description: "Cerdo marinado en una capa dorada y crujiente." },
            { name: "Carne Asada", price: 10, description: "Filete tierno envuelto en una corteza deliciosa." },
        ],
    },
    {
        name: "Tortillas",
        description: "Tortillas de maíz hechas a mano, perfectas para cualquier comida.",
        image: tortillasImage,
        options: [
            { name: "1/2 Libra", price: 3, description: "Media libra de tortillas recién hechas." },
            { name: "1 Libra", price: 5, description: "Una libra completa de tortillas suaves y hechas a mano." },
        ],
    },
    {
        name: "Bebidas",
        description: "Algo para saciar la sed.",
        image: beveragesImage,
        options: [
            { name: "Refresco en Lata", price: 2, description: "Refresco clásico en lata." },
            { name: "Refresco en Botella", price: 3, description: "Refresco refrescante servido en botella." },
            {
                name: "Agua Fresca",
                price: 5,
                description: "Dulce, refrescante y perfectamente fría — elige entre melón chino, piña, sandía, horchata, jamaica o limonada verde. Ingredientes 100% naturales",
            },
        ],
    },
];

export const seoTitleEs = "La Estrellita | Menú";

export default menuES;
